import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useSearchParams } from "react-router-dom";
import { useLicense } from "../_helper/LicenseContext";
import { useLab } from "../_helper/PharmacyProvider";

const PrivateRoute = () => {
  // const isLoggedIn = !!localStorage.getItem("currentLab");
  const { licenseStatus, isChecking } = useLicense();
  const [initialCheckComplete, setInitialCheckComplete] = useState(false);
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const { currentLab } = useLab()

  // Track when initial validation completes
  useEffect(() => {
    if (!isChecking && !initialCheckComplete) {
      setInitialCheckComplete(true);
    }
  }, [isChecking, initialCheckComplete]);

  // if (!isLoggedIn) {
  //   return <Navigate to={`${process.env.PUBLIC_URL}/login`} replace />;
  // }

  const isAuthenticated = currentLab || localStorage.getItem("currentLab");

  if (!isAuthenticated) {
    if (token) {
      return (
        <div style={{
          padding: 50,
          textAlign: "center",
          display: 'flex',
          alignItems: 'end',
          justifyContent: 'center',
          minHeight: '100vh'
        }}>
          <div>
            {/* <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div> */}
            <p style={{ marginTop: '20px' }}>Authenticating...</p>
          </div>
        </div>
      );
    }
    return <Navigate to={`${process.env.PUBLIC_URL}/login`} replace />;
  }

  // Show loading screen during initial validation
  if (!initialCheckComplete) {
    return (
      <div style={{
        padding: 50,
        textAlign: "center",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh'
      }}>
        <div>
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
          <p style={{ marginTop: '20px' }}>Validating license...</p>
        </div>
      </div>
    );
  }

  // Once validation is complete, check status
  if (licenseStatus === 'valid') {
    return <Outlet />;
  }

  // IMMEDIATELY redirect for any invalid status
  if (licenseStatus === 'time-tampered') {
    return <Navigate to={`${process.env.PUBLIC_URL}/activate?error=time-tamper`} replace />;
  }

  if (licenseStatus === 'expired') {
    return <Navigate to={`${process.env.PUBLIC_URL}/activate?error=expired`} replace />;
  }

  // For all other statuses (invalid, none, etc)
  console.log(licenseStatus);
  return <Navigate to={`${process.env.PUBLIC_URL}/activate`} replace />;
};

export default PrivateRoute;